import React, { ReactNode } from "react";
import { DownloadConfirmDialog } from "../DownloadConfirmDialog/DownloadConfirmDialog";

interface AppWrapperProps {
  children: ReactNode;
  showDownloadDialog: boolean;
  downloadInfo: any;
  isLoadingAssetInfo: boolean;
  onConfirmDownload: () => void;
  onCancelDownload: () => void;
}

export const AppWrapperComponent: React.FC<AppWrapperProps> = ({
  children,
  showDownloadDialog,
  downloadInfo,
  isLoadingAssetInfo,
  onConfirmDownload,
  onCancelDownload,
}) => {
  return (
    <>
      {children}
      <DownloadConfirmDialog
        showDialog={showDownloadDialog}
        downloadInfo={downloadInfo}
        isLoadingAssetInfo={isLoadingAssetInfo}
        onConfirm={onConfirmDownload}
        onCancel={onCancelDownload}
      />
    </>
  );
};
